<template>
  <v-container class="settings-container">
    <!-- Main Settings Card -->
    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="primary-header">
        <v-icon class="ml-2" dark>mdi-cog</v-icon>
        הגדרות מערכת
      </v-card-title>

      <v-card-text>
        <div class="settings-grid">
          <!-- Public Recording Permissions -->
          <div class="setting-section" v-if="showRecordPublicEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-record-circle</v-icon>
              <span class="setting-title">הרשאות הקלטה ציבורית:</span>
            </div>
            <v-radio-group v-model="radioGroup.public_record_permission" row class="mt-2">
              <v-radio v-for="option in publicRecordPermissionOptions" :key="option.value" :label="option.label"
                :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Private Recording Permissions -->
          <div class="setting-section" v-if="showRecordPrivateEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-record-circle</v-icon>
              <span class="setting-title">הרשאות הקלטה פרטית:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_record_private" row class="mt-2">
              <v-radio v-for="option in groupType" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Language -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-translate</v-icon>
              <span class="setting-title">שפה:</span>
            </div>
            <v-radio-group v-model="radioGroup.language" row class="mt-2">
              <v-radio v-for="option in languageList" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Group Member Addition -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-account-multiple-plus</v-icon>
              <span class="setting-title">הוספת חברים לקבוצה ע"י כל משתמש:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_add_subscribers" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Open Line -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-phone</v-icon>
              <span class="setting-title">קו פתוח לכולם:</span>
            </div>
            <v-radio-group v-model="radioGroup.isIvrOpen" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Message Sharing -->
          <div class="setting-section" v-if="showShareRecordEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-share-variant</v-icon>
              <span class="setting-title">שיתוף הודעות:</span>
            </div>
            <v-radio-group v-model="radioGroup.share_record" row class="mt-2">
              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Conference Room Mode: regular conference or live broadcast -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-broadcast</v-icon>
              <span class="setting-title">סוג חדר הוועידה:</span>
            </div>
            <v-radio-group v-model="radioGroup.conference_mode" row class="mt-2">
              <v-radio v-for="option in conferenceModeOptions" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
            <p class="setting-hint">{{ conferenceModeHint }}</p>
          </div>

          <!-- Conference Room Opening -->
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-account-group</v-icon>
              <span class="setting-title">פתיחת חדר ועידה:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_open_conference" row class="mt-2">
              <v-radio v-for="option in groupType" :key="option" :label="option" :value="option" color="#0d2c6d"
                class="ml-1"></v-radio>
            </v-radio-group>
          </div>

          <!-- Conference Join/Leave Sound: מוסתר - השלוחה לא משתמשת בהגדרה הזו (הקוד שבוחר את הצלילים בהערה ב-agiHandlersExt8.js).
               הערך עדיין נטען ונשמר כמו שהוא, כי general_settings נשמר בשלמותו
          <div class="setting-section">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-bullhorn</v-icon>
              <span class="setting-title">צליל כניסה/יציאה מחדר ועידה:</span>
            </div>
            <v-radio-group v-model="radioGroup.conference_join_leave_sound" row class="mt-2">
              <v-radio v-for="option in conferenceJoinLeaveOptions" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>
          -->


          <!-- AI Assistant (ext 3) - מוסתר כשהאדמין/הסוכן חסמו -->

          <div class="setting-section" v-if="showAiAssistantEdit">

            <div class="setting-header">

              <v-icon color="#0d2c6d" class="ml-2">mdi-robot-outline</v-icon>

              <span class="setting-title">עוזר קולי (AI) בשלוחה 3:</span>

            </div>

            <v-radio-group v-model="radioGroup.aiAssistant" row class="mt-2" persistent-hint
              hint="למי העוזר פתוח תלוי בחבילה של המערכת: לכל המאזינים, או רק למאזינים עם מנוי רב קול.">

              <v-radio v-for="option in addSubscribePermission" :key="option" :label="option" :value="option"

                color="#0d2c6d" class="ml-1"></v-radio>

            </v-radio-group>

          </div>

          <!-- יצירת סקרים (שלוחה 11) - מוצג רק כשהאדמין/הסוכן אפשרו את שלוחת הסקרים -->
          <div class="setting-section" v-if="showSurveysEdit">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-poll</v-icon>
              <span class="setting-title">מי יכול ליצור סקרים בשלוחת הסקרים:</span>
            </div>
            <v-radio-group v-model="radioGroup.all_can_create_survey" row class="mt-2" persistent-hint
              hint="מנהלים יכולים תמיד. מי שיוצר סקר יכול גם לשלוח עליו צינתוק לכל החברים.">
              <v-radio v-for="option in groupType" :key="option" :label="option" :value="option"
                color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <!-- Security Card -->
    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="secondary-header">
        <v-icon class="ml-2">mdi-shield-lock</v-icon>
        אבטחה ופרטיות
      </v-card-title>

      <v-card-text>
        <!-- System Password -->
        <div class="setting-section">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="ml-2">mdi-lock</v-icon>
            <span class="setting-title">סיסמה למערכת:</span>
          </div>
          <v-radio-group v-model="radioGroup.system_password" row class="mt-2">
            <v-radio v-for="option in systemPasswordOptions" :key="option" :label="option" :value="option"
              color="#0d2c6d" class="ml-1"></v-radio>
          </v-radio-group>

          <v-slide-y-transition>
            <v-text-field v-if="radioGroup.system_password === 'אפשר'" v-model="details.system_password"
              label="הזן סיסמת כניסה (4 ספרות)" maxlength="4" outlined dense class="mt-3 password-field" :rules="[
                v => !v || /^\d+$/.test(v) || 'הסיסמה כוללת ספרות בלבד',
                v => !v || v.length === 4 || 'הסיסמה חייבת לכלול 4 ספרות'
              ]"></v-text-field>
          </v-slide-y-transition>
        </div>

        <!-- Skip System Password For -->
        <v-slide-y-transition>
          <div class="setting-section alternate" v-if="radioGroup.system_password === 'אפשר'">
            <div class="setting-header">
              <v-icon color="#0d2c6d" class="ml-2">mdi-account-key</v-icon>
              <span class="setting-title">דילוג על סיסמת המערכת עבור:</span>
            </div>
            <v-radio-group v-model="radioGroup.skipSysPasswordFor" row class="mt-2">
              <v-radio v-for="option in skipSysPasswordForOptions" :key="option.value" :label="option.label"
                :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
            </v-radio-group>
          </div>
        </v-slide-y-transition>

        <!-- Delete After 30 Days -->
        <div class="setting-section alternate">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="ml-2">mdi-delete-clock</v-icon>
            <span class="setting-title">מחיקת הקלטות לאחר 30 יום:</span>
          </div>
          <v-radio-group v-model="radioGroup.delete_after_thirty_days" row class="mt-2">
            <v-radio v-for="option in deleteAfterThirtyDays" :key="option.hebrewName" :label="option.hebrewName"
              :value="option.value" color="#0d2c6d" class="ml-1"></v-radio>
          </v-radio-group>
        </div>
      </v-card-text>
    </v-card>

    <!-- Regional Settings Card -->
    <v-card class="mb-6 settings-card" elevation="2">
      <v-card-title class="tertiary-header">
        <v-icon class="ml-2">mdi-earth</v-icon>
        הגדרות אזוריות
      </v-card-title>

      <v-card-text>
        <!-- Timezone -->
        <div class="setting-section">
          <div class="setting-header">
            <v-icon color="#0d2c6d" class="ml-2">mdi-clock-time-four</v-icon>
            <span class="setting-title">אזור זמן (UTC):</span>
          </div>
          <v-autocomplete v-model="radioGroup.timezone" :items="timezones" item-text="label" item-value="value"
            label="בחר אזור זמן" outlined dense hide-details="auto" class="mt-2 timezone-select"></v-autocomplete>
        </div>
      </v-card-text>
    </v-card>

    <!-- Action Buttons -->
    <div class="d-flex justify-end mb-8">
      <v-btn color="primary" x-large :loading="progressShow" :disabled="progressShow" @click="saveChanges"
        class="save-button">
        <v-icon left>mdi-content-save</v-icon>
        שמור שינויים
      </v-btn>
    </div>

    <!-- Loading Indicator -->
    <v-overlay :value="progressShow" absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>

    <!-- Notification -->
    <SnackBar v-model="snackbar" :snacbarText="snacbarText" :snackbarColorBt="snackbarColorBt"></SnackBar>
  </v-container>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'
import moment from 'moment-timezone';

export default {
  components: {
    SnackBar,
  },
  data: () => ({
    snackbar: false,
    snackbarColorBt: "success",
    snacbarText: "",
    radioGroup: {
      public_record_permission: null,
      all_can_record_private: null,
      timezone: '', // selected value
      language: null,
      all_can_add_subscribers: null,
      delete_after_thirty_days: null,
      system_password: null,
      skipSysPasswordFor: 'none',
      isIvrOpen: null,
      share_record: null,
      all_can_open_conference: null,
      conference_mode: null,
      conference_join_leave_sound: null,
      aiAssistant: null,
      all_can_create_survey: null
    },
    progressShow: false,
    groupType: ["כולם", "רק מנהלים"],
    publicRecordPermissionOptions: [
      { label: "כולם", value: "all" },
      { label: "רק מנהלים", value: "managers" },
      { label: "כולם - באישור מנהל", value: "allAdminApproval" }
    ],
    // languageList: ["עברית", "אנגלית", "אידיש ישראלי", "אידיש אמריקאי"],
    languageList: ["עברית", "אידיש ישראלי"],
    addSubscribePermission: ["כן", "לא"],
    deleteAfterThirtyDays: [{ hebrewName: "כן", value: true }, { hebrewName: "לא", value: false }],
    systemPasswordOptions: ["לא פעיל", "אפשר"],
    skipSysPasswordForOptions: [
      { label: "אף אחד", value: "none" },
      { label: "מנהלים ובעלים", value: "manager" },
      { label: "בעלים בלבד", value: "owner" },
      { label: "משתמשים שנוספו ידנית", value: "manualJoinSubscriber" }
    ],
    conferenceJoinLeaveOptions: ["כולם", "אף אחד"],
    conferenceModeOptions: ["ועידה רגילה", "שידור חי"],
    details: {},
    showRecordPublicEdit: true,
    showRecordPrivateEdit: true,
    showShareRecordEdit: true,
    showAiAssistantEdit: true,
    showSurveysEdit: true,
  }),
  computed: {
    // הסבר מתחת לבחירה, לפי מה שנבחר עכשיו (גם לפי "פתיחת חדר ועידה")
    conferenceModeHint() {
      if (this.radioGroup.conference_mode !== "שידור חי") {
        return "כל מי שנכנס לחדר יכול לדבר ולשמוע.";
      }
      if (this.radioGroup.all_can_open_conference === "רק מנהלים") {
        return "המנהל הראשון שנכנס לחדר מדבר, וכל השאר מאזינים מושתקים, בלי אפשרות לבטל את ההשתקה. מי שנכנס לפניו שומע מוזיקת המתנה. כשהדובר יוצא, השידור מסתיים לכולם.";
      }
      return "הראשון שנכנס לחדר מדבר, וכל השאר מאזינים מושתקים, בלי אפשרות לבטל את ההשתקה. כשהדובר יוצא, השידור מסתיים לכולם.";
    },
    timezones() {
      return this.getAllTimezones();
    },
  },
  methods: {
    async getSettingsDetails() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/settings/get_settings_details`;
        const res = await fetch(api, ApiServices.requestOptions("GET", "", token));
        const jsonObject = await res.json();

        if (res.status >= 400) {
          this.showSnackBar("שגיאה בקבלת נתונים", "error");
        } else if (res.status === 200) {
          this.details = jsonObject;
          this.setSystemSettings();
        }
      } catch (error) {
        this.showSnackBar("Error get files: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    getAllTimezones() {
      return moment.tz.names().map(tz => {
        const offset = moment.tz(tz).utcOffset();
        const hours = Math.floor(offset / 60);
        const minutes = Math.abs(offset % 60);
        const label = `(UTC${hours >= 0 ? '+' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}) ${tz}`;

        return {
          label,
          value: tz
        };
      });
    },

    setSystemSettings() {
      if (!this.details.exten_permissions.all_can_record_public) {
        this.showRecordPublicEdit = false;
      }

      if (!this.details.exten_permissions.all_can_record_private) {
        this.showRecordPrivateEdit = false;
      }

      if (!this.details.exten_permissions.share_record) {
        this.showShareRecordEdit = false;
      }

      // חסום ע"י האדמין/הסוכן -> לא מציגים
      if (!this.details.exten_permissions.aiAssistant) {
        this.showAiAssistantEdit = false;
      }
      this.radioGroup.aiAssistant = this.details.general_settings.aiAssistant ? "כן" : "לא";

      // יצירת סקרים: מוצג רק כשהאדמין/הסוכן אפשרו את שלוחת הסקרים.
      // הערך נטען תמיד, כדי שבשמירה יישלח הערך הקיים גם כשהשדה מוסתר
      if (!this.details.exten_permissions.surveys) {
        this.showSurveysEdit = false;
      }
      this.radioGroup.all_can_create_survey = this.details.general_settings.all_can_create_survey === false ? "רק מנהלים" : "כולם";

      this.radioGroup.public_record_permission = this.details.general_settings.public_record_permission || "all";

      if (this.details.general_settings.all_can_record_private) {
        this.radioGroup.all_can_record_private = "כולם"
      } else {
        this.radioGroup.all_can_record_private = "רק מנהלים"
      }

      if (this.details.general_settings.language === 'he') {
        this.radioGroup.language = "עברית"
      } else if (this.details.general_settings.language === 'en') {
        this.radioGroup.language = "אנגלית"
      } else if (this.details.general_settings.language === 'yi_il') {
        this.radioGroup.language = "אידיש ישראלי"
      } else {
        this.radioGroup.language = "אידיש אמריקאי"
      }

      if (this.details.general_settings.all_can_add_subscribers) {
        this.radioGroup.all_can_add_subscribers = "כן"
      } else {
        this.radioGroup.all_can_add_subscribers = "לא"
      }

      if (this.details.general_settings.isIvrOpen) {
        this.radioGroup.isIvrOpen = "כן"
      } else {
        this.radioGroup.isIvrOpen = "לא"
      }

      if (this.details.general_settings.share_record) {
        this.radioGroup.share_record = "כן"
      } else {
        this.radioGroup.share_record = "לא"
      }

      if (this.details.general_settings.all_can_open_conference) {
        this.radioGroup.all_can_open_conference = "כולם"
      } else {
        this.radioGroup.all_can_open_conference = "רק מנהלים"
      }

      this.radioGroup.conference_mode = this.details.general_settings.conference_mode === "broadcast" ? "שידור חי" : "ועידה רגילה";

      const joinLeaveSound = this.details.general_settings.conference_join_leave_sound;
      if (joinLeaveSound === 'all') {
        this.radioGroup.conference_join_leave_sound = "כולם"
      } else {
        this.radioGroup.conference_join_leave_sound = "אף אחד"
      }

      if (this.details.system_password) {
        this.radioGroup.system_password = "אפשר"
      } else {
        this.radioGroup.system_password = "לא פעיל"
      }

      this.radioGroup.skipSysPasswordFor = this.details.general_settings.skipSysPasswordFor || 'none';

      if (this.details.delete_settings.delete_after_thirty_days) {
        this.radioGroup.delete_after_thirty_days = true
      } else {
        this.radioGroup.delete_after_thirty_days = false
      }

      this.radioGroup.timezone = this.details.general_settings.timezone;
    },

    async saveChanges() {
      try {
        if (this.radioGroup.system_password === "אפשר" && this.details.system_password) {
          const numberRegex = /^\d+$/; // Only numeric characters
          const isValidFormat = numberRegex.test(this.details.system_password);
          if (!isValidFormat) {
            return this.showSnackBar("הסיסמה כוללת ספרות בלבד", "error");
          }
          if (this.details.system_password.length != 4) {
            return this.showSnackBar("הסיסמה חייבת לכלול 4 ספרות", "error");
          }
        }

        const updatedObj = {
          system_password: this.radioGroup.system_password === "אפשר" ? this.details.system_password : "",
          delete_settings: { delete_after_thirty_days: this.radioGroup.delete_after_thirty_days },
          general_settings: {
            language: this.radioGroup.language === "עברית" ? "he" :
              this.radioGroup.language === "אנגלית" ? "en" :
                this.radioGroup.language === "אידיש ישראלי" ? "yi_il" : "yi-us",
            isIvrOpen: this.radioGroup.isIvrOpen === "כן" ? true : false,
            public_record_permission: this.radioGroup.public_record_permission,
            all_can_record_private: this.radioGroup.all_can_record_private === "כולם" ? true : false,
            all_can_add_subscribers: this.radioGroup.all_can_add_subscribers === "כן" ? true : false,
            share_record: this.radioGroup.share_record === "כן" ? true : false,
            all_can_open_conference: this.radioGroup.all_can_open_conference === "כולם" ? true : false,
            conference_join_leave_sound: this.radioGroup.conference_join_leave_sound === "כולם" ? "all" : "none",
            // חובה לשלוח: בלי השדה, כל שמירה בדף הייתה מחזירה מערכת במצב שידור לוועידה רגילה
            conference_mode: this.radioGroup.conference_mode === "שידור חי" ? "broadcast" : "conference",
            aiAssistant: this.radioGroup.aiAssistant === "כן" ? true : false,
            // חובה לשלוח: השרת שומר את general_settings כולו, ושדה שלא נשלח חוזר לברירת המחדל
            all_can_create_survey: this.radioGroup.all_can_create_survey !== "רק מנהלים",
            timezone: this.radioGroup.timezone,
            skipSysPasswordFor: this.radioGroup.system_password === "אפשר" ? this.radioGroup.skipSysPasswordFor : 'none',
          }
        }

        this.progressShow = true;
        const detailsJSON = JSON.stringify({ updatedObj });
        let token = localStorage.getItem("token");
        let api = process.env.VUE_APP_BASE_URL + `/settings/save_changes`;
        const res = await fetch(api, ApiServices.requestOptions("PUT", detailsJSON, token));

        if (res.status >= 400) {
          this.showSnackBar("שגיאה בשמירת השינויים", "error");
        } else if (res.status === 200) {
          this.showSnackBar("השינויים עודכנו בהצלחה!", "success");
          this.$store.commit('SET_TIMEZONE', this.radioGroup.timezone);
        }
      } catch (error) {
        this.showSnackBar("Error save changes: " + error, "error");
      } finally {
        this.progressShow = false;
      }
    },

    showSnackBar(message, color) {
      this.snacbarText = message;
      this.snackbarColorBt = color === "error" ? "red" : "green";
      this.snackbar = true;
    },
  },

  mounted() {
    this.getSettingsDetails();
  },
}
</script>

<style scoped>
.settings-container {
  max-width: 1200px;
  margin: 0 auto;
  direction: rtl;
  font-family: 'Heebo', sans-serif;
}

.settings-card {
  border-radius: 8px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.settings-card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
}

.primary-header {
  background: linear-gradient(135deg, #0d2c6d 0%, #1a4ba5 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.secondary-header {
  background: linear-gradient(135deg, #ffb91a 0%, #ffd166 100%);
  color: #0d2c6d;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.tertiary-header {
  background: linear-gradient(135deg, #6a6aec 0%, #8a8aff 100%);
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  padding: 16px;
}

.settings-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
}

.settings-grid>.setting-section {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-left: 1px solid rgba(0, 0, 0, 0.05);
}

.settings-grid>.setting-section:nth-child(odd) {
  border-left: none;
}

.setting-section {
  padding: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.setting-section.alternate {
  background-color: rgba(0, 0, 0, 0.02);
}

.setting-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.setting-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #0d2c6d;
}

.timezone-select {
  max-width: 400px;
}

.password-field {
  max-width: 200px;
}

.save-button {
  background: linear-gradient(0deg, rgba(255, 185, 26, 1) 0%, rgba(255, 185, 26, 0.8) 100%);
  color: #0d2c6d;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 0 32px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.save-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

/* Radio button styling */
:deep(.v-radio label) {
  font-weight: 500;
}

:deep(.v-input--radio-group__input) {
  margin-top: 8px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .settings-container {
    padding: 16px;
  }

  .settings-grid {
    grid-template-columns: 1fr;
  }

  .settings-grid>.setting-section {
    border-left: none;
  }

  .primary-header,
  .secondary-header,
  .tertiary-header {
    font-size: 1.25rem;
  }

  .setting-title {
    font-size: 1rem;
  }
}

@media (max-width: 600px) {
  .save-button {
    width: 100%;
  }

  :deep(.v-radio-group) {
    flex-direction: column !important;
  }

  :deep(.v-radio) {
    margin-bottom: 8px;
  }
}

/* הסבר קצר מתחת להגדרה (סוג חדר הוועידה) */
.setting-hint {
  margin: -6px 0 0;
  font-size: 13px;
  line-height: 1.5;
  color: #6b7690;
}
</style>